import { inRange } from 'lodash-es';

import type { AnyNumberScale } from '../../../types/scales.js';
import { isZoomBoundaries } from '../../../utils/zoom.js';
import type { ZoomBehavior } from '../../interactions-overlay/types.js';

export const getZoomStep = (
  currentScale: AnyNumberScale,
  initialDomain: [number, number],
  infiniteZoom: boolean = false,
  deltaStart: number,
  deltaEnd: number,
  behaviour: ZoomBehavior | undefined = undefined,
): {
  nextDomain: [number, number] | [Date, Date];
  zoomInEnabled: boolean;
  zoomOutEnabled: boolean;
} => {
  const [rangeMin, rangeMax] = currentScale.range();
  const currentDomain = currentScale.domain() as
    | [number, number]
    | [Date, Date];

  const initialMin = initialDomain[0];
  const initialMax = initialDomain[1];

  const minAsPx = behaviour === 'zoom-x' ? deltaStart : rangeMin + deltaStart;
  const maxAsPx = behaviour === 'zoom-x' ? deltaEnd : rangeMax + deltaEnd;

  let newMin = currentScale.invert(minAsPx).valueOf();
  let newMax = currentScale.invert(maxAsPx).valueOf();

  if (!infiniteZoom) {
    if (!inRange(newMin, initialMin, initialMax)) {
      newMin = initialMin;
    }

    if (!inRange(newMax, initialMin, initialMax)) {
      newMax = initialMax;
    }
  }

  const nextDomain: [number, number] = [newMin, newMax];

  const { isMinZoom, isMaxZoom } = isZoomBoundaries(
    [initialMin, initialMax],
    nextDomain,
    infiniteZoom,
  );

  const zoomInEnabled = !isMaxZoom;
  const zoomOutEnabled = !isMinZoom;

  return {
    nextDomain: isMaxZoom ? currentDomain : nextDomain,
    zoomInEnabled,
    zoomOutEnabled,
  };
};
